// extracted by mini-css-extract-plugin
export default {"root":"stocksHeading_root__ky6G0","input":"stocksHeading_input__8FIML","containerIcon":"stocksHeading_containerIcon__dd-0u","icon":"stocksHeading_icon__c9QYO"};